(function(){
function init(){
if(!matchMedia('(max-width: 59.99em)').matches)return;
document.querySelectorAll('.product__media[data-mobile-gallery-style="slider"]').forEach(function(g){
if(g.dataset.pixieLoop)return;
var items=[].slice.call(g.children).filter(function(el){return el.classList.contains('product__media-item');});
if(items.length<2)return;
g.dataset.pixieLoop='1';
function clone(el){var c=el.cloneNode(true);c.removeAttribute('data-media-item-id');c.removeAttribute('data-product-media-wrapper');c.setAttribute('aria-hidden','true');c.querySelectorAll('[id]').forEach(function(x){x.removeAttribute('id');});return c;}
items.forEach(function(el){g.appendChild(clone(el));});
for(var i=items.length-1;i>=0;i--)g.insertBefore(clone(items[i]),g.firstChild);
function pos(el){return el.getBoundingClientRect().left-g.getBoundingClientRect().left+g.scrollLeft;}
function jumpTo(x){g.style.scrollSnapType='none';g.scrollLeft=x;void g.offsetWidth;g.style.scrollSnapType='';}
function setW(){return pos(items[0])-pos(g.firstElementChild);}
function center(){jumpTo(pos(items[0]));}
requestAnimationFrame(center);
setTimeout(function(){if(g.scrollLeft<5)center();},600);
var t;
g.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){var a=pos(items[0]),w=setW();if(g.scrollLeft>=a+w-2)jumpTo(g.scrollLeft-w);else if(g.scrollLeft<a-2)jumpTo(g.scrollLeft+w);},120);},{passive:true});
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
